import { loader } from 'graphql.macro'
import globalStyle from '../../styles/common.module.css'
import style from './pages.module.css'
import { GraphQLClient } from 'graphql-request'
import { GQL_ENDPOINT } from '../../util/consts'
import { useCallback, useEffect, useState } from 'react'
import { VideosQuery } from '../../util/types'
import { Videos } from '../story/Videos'

const videosQuery = loader('../../queries/videos.graphql')
const client = new GraphQLClient(GQL_ENDPOINT)

export function VideosPage() {
  const { videosData, error } = useVideosData()

  if (error) {
    console.error(error)
    return <p> Oops something went wrong </p>
  }

  return (
    <div className={[globalStyle.grid10, globalStyle.gridCenter].join(' ')}>
      <div className={[globalStyle.grid6, globalStyle.paddingBottom].join(' ')}>
        <h1 className={[globalStyle.heading1, style.header].join(' ')}> Videos </h1>
      </div>

      <div style={{ marginTop: 'var(--space-xl)' }}>
        <Videos items={videosData || []} />
      </div>
    </div>
  )
}

type Video = VideosQuery["stories"][number]["videos"][number]
function useVideosData() {
  const [videosData, setVideosData] = useState<Video[] | null>(null)
  const [error, setError] = useState<Error | null>(null)

   const fetchData = useCallback(() => {
     client.request(videosQuery)
        .then((videosResponse: VideosQuery) => {
         setVideosData(videosResponse.stories.flatMap((story: VideosQuery["stories"][number]) => story.videos))
       })
       .catch((err) => {
         setError(err)
         console.error('query error', err)
       })
   }, [])

   useEffect(() => {
     fetchData()
   }, [fetchData])

   return { videosData, error }
}